import styles from './index.module.scss'
import { useState, useEffect, useContext, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { AppContext } from '@utils/AppContext';
import Iconfont from '@utils/Iconfont';

const PersonalSidebar = () => {
    const { globalOrgInfo } = useContext(AppContext)
    const navigate = useNavigate()
    const location = useLocation()
    const [activeIndex, setActiveIndex] = useState()

    const sidebarList = useMemo(() => {
        if(location.pathname == '/home/personalCenter/redemptioncodeList') {
            return [{
                title: '兑换码管理',
                path: 'redemptioncodeList',
                icon: 'icon-redemptioncodeOutlined'
            }]
        }
        const list = [{
            title: '成员管理',
            path: 'memberManage',
            icon: 'icon-reuse'
        }, {
            title: '虹豆明细',
            path: 'personalTransaction',
            icon: 'icon-beamdetails'
        }, {
            title: '订单明细',
            path: 'personalOrder',
            icon: 'icon-orderDetailsOutlined'
        }, {
            title: '个人资料',
            path: 'personalInformation',
            icon: 'icon-username'
        }]
        
        // 如果是个人版，移除企业管理项；否则移除个人资料项
        if (globalOrgInfo?.isPersonal) {
            return list.filter(item => item.title !== '成员管理')
        } else {
            return list.filter(item => item.title !== '个人资料')
        }
    }, [globalOrgInfo?.isPersonal, location.pathname])

    useEffect(() => {
        const path = window.location.pathname.split('/').pop()
        setActiveIndex(path)
    }, [location.pathname])

    const handleClick = (path) => {
        setActiveIndex(path)
        navigate(`/home/personalCenter/${path}`)
    }

    return (
        <div className={styles.personalSidebar}>
            <div className={styles.title}>
                {location.pathname == '/home/personalCenter/redemptioncodeList'? '分销管理': 
                globalOrgInfo?.isPersonal ? '个人中心' : '企业管理'}</div>
            {
                sidebarList.map((item, index) => (
                    <div key={index}
                        className={`${styles.sidebarItem} ${activeIndex == item.path ? styles.active : ''}`}
                        onClick={() => handleClick(item.path)}
                    >
                        <Iconfont className={styles.Icon} type={item.icon} /> {item.title}
                    </div>
                ))
            }
        </div>
    )
}

export default PersonalSidebar